import { render } from "./AddTaxRule.vue?vue&type=template&id=4890afc8&ts=true"
import script from "./AddTaxRule.vue?vue&type=script&lang=ts"
export * from "./AddTaxRule.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__